export default "__VITE_ASSET__DP$3PO_Q__"